import React from 'react';
import PropTypes from 'prop-types';

import Loading from 'react/components/Loading';
import { FormSection, FormSectionColumn } from 'react/containers/layout/Crud';
import { TextField, TextAreaField } from 'react/components/fields';
import { getResourceTo } from 'react/utils/utils';

function Metadata(props) {
  const {
    idpName,
    idpURL,
    idpCertificate,
    isValidating,
    isValid,
    isInvalid,
    idpValidationError,
    stopIdpUrlValidationAction,
    initializeIdpUrlValidationAction
  } = props;

  const validate = () => {
    if (idpURL) {
      initializeIdpUrlValidationAction({ idpURL });
    }
  };

  const handleFocus = () => {
    stopIdpUrlValidationAction();
  };

  return (
    <FormSection
      title={getResourceTo('samlConfiguration.metadataSection.title', idpName)}
      subtitle="samlConfiguration.metadataSection.subtitle"
      className="metadataSection"
    >
      <FormSectionColumn>
        <TextField
          description="idpURL"
          label="samlConfiguration.idpURL"
          name="idpURL"
          required
          onBlur={validate}
          onFocus={handleFocus}
        />
        {isValidating && !isValid && (
          <div className="loadingWrapper">
            <Loading width="16px" height="16px" theme="blue" />
            <p className="loadingLabel">
              {getResourceTo('samlConfiguration.metadataSection.isValidating')}
            </p>
          </div>
        )}
        {(isValid && !isValidating) && (
          <div className="isValid">
            <div className="isValid-icon" />
            <p className="isValid-label">
              {getResourceTo('samlConfiguration.metadataSection.isValid')}
            </p>
          </div>
        )}
        {isInvalid && idpValidationError && (
          <div className="isInvalid">
            <p className="isInvalid-label">{idpValidationError}</p>
          </div>
        )}
        <TextAreaField
          name="idpCertificate"
          label="samlConfiguration.idpCertificate"
          description="idpCertificate"
          defaultValue={idpCertificate}
          shouldShow={false}
          disabled
        />
      </FormSectionColumn>
    </FormSection>
  );
}

Metadata.propTypes = {
  idpName: PropTypes.string,
  idpURL: PropTypes.string,
  isValidating: PropTypes.string,
  stopIdpUrlValidationAction: PropTypes.func.isRequired,
  initializeIdpUrlValidationAction: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  isInvalid: PropTypes.bool.isRequired,
  idpValidationError: PropTypes.string.isRequired,
  idpCertificate: PropTypes.string
};

Metadata.defaultProps = {
  idpName: '',
  idpURL: '',
  isValidating: '',
  idpCertificate: ''
};

export default Metadata;
